import Notifications from 'components/Notifications';
import Auth from 'containers/Auth';
import CreateNewClassForm from 'containers/CreateNewClassForm';
import WelcomeBackModal from 'components/WelcomeBackModal';
import React from 'react';
import { Provider } from 'react-redux';
import { HashRouter as Router } from 'react-router-dom';
import store from 'store';

import App from './App';

const Base = () => (
  <main>
    <Provider store={store}>
      <Router>
        <Auth>
          <CreateNewClassForm />
          <WelcomeBackModal />
          <Notifications />
          <App />
        </Auth>
      </Router>
    </Provider>
  </main>
);

export default Base;
